/**
 * Authenticated API Client
 * Simple wrapper that provides an authenticated HTTP client instance
 */

import { getAuthenticatedHttpClient, resetAuthenticatedHttpClient } from './apiIntegration';

/**
 * Get the authenticated HTTP client instance
 * This is the main export that should be used throughout the application
 */
export const apiClient = getAuthenticatedHttpClient();

/**
 * Reset the authenticated API client
 * Useful for testing or when switching users
 */
export function resetApiClient(): void {
    resetAuthenticatedHttpClient();
}
